"use strict";

var KEYCODE_ESC = 27;
document.addEventListener('click', function handleClickOutsideBox(event) {
  var filterBarItemsChecked = document.querySelectorAll(".filter_bar__item__checkbox.checked");
  filterBarItemsChecked && filterBarItemsChecked.forEach(function (item) {
    var itemParent = item.parentNode;
    var eventTarget = event.target;
    if (!itemParent.contains(eventTarget)) {
      itemParent.querySelector(":scope > .filter_bar__item__label").click();
      return;
    }
  });
});
document.addEventListener('keydown', function handleEscape(event) {
  if (event.key === "Escape" || event.keyCode === KEYCODE_ESC) {
    var filterBarItemsChecked = document.querySelectorAll(".filter_bar__item__checkbox.checked");
    if (filterBarItemsChecked) {
      var last = filterBarItemsChecked.length - 1;
      filterBarItemsChecked[last].parentNode.querySelector(":scope > .filter_bar__item__label").click();
    }
  }
});